import { render, staticRenderFns } from "./category-selector.vue?vue&type=template&id=5644ee54"
import script from "./category-selector.vue?vue&type=script&lang=js"
export * from "./category-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports